<mat-form-field appearance="outline" floatLabel="always" [class.has-selected]="hasSelection" [id]="idPrefix + '-input'">

  <!-- Prefix -->
  @if (prefix || prefixTemplate) {
    <div matPrefix>
      @if (prefixTemplate) {
        <template [ngTemplateOutlet]="prefixTemplate" ></template>
      } @else {
        @if (prefix) {
          <span>{{prefix}}</span>
        }
      }
    </div>
  }

  <mat-label>{{label}}</mat-label>
  <input class="d-none" lcTestId matInput [errorStateMatcher]="matcher" [formControl]="formControl">

  <mat-chip-grid #chipList aria-label="Chips Selection" class="w-100">
    @for (option of chipOptions; track option) {
      @if (option.isSelected) {
        <mat-chip-row
          [ngClass]="size"
          [removable]="true"
          (removed)="onItemRemoved(option)">
          @if (tagTemplate?.elementRef === null) {
            {{option.label || option.value}}
          } @else {
            <template [ngTemplateOutlet]="tagTemplate" [ngTemplateOutletContext]="{item: option.value, label: option.label}"></template>
          }
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
    }
    <input
      #chipInput
      lcTestId
      required
      [disabled]="!canAdd"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [placeholder]="hasSelection ? '' : placeholder"
      (input)="onUserInput($event)" (matChipInputTokenEnd)="onInputAdd($event)">
  </mat-chip-grid>

  <mat-hint>{{hint}}</mat-hint>
  @if (errors) {
    <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }
  <!-- <mat-error [id]="idPrefix + '-error'" *ngIf="inputFormControl && inputFormControl.invalid && errors" [innerHTML]="errors"></mat-error> -->

  <mat-autocomplete #auto="matAutocomplete" class="z-2000" lcTestId (change)="selectedChanged.emit($event)" (optionSelected)="onSelected($event)">
    <!-- No Results Option: Displays when 0 results-->
    @if (chipOptions?.length === 0 && noResultsDisplay) {
      <mat-option class="no-results" disabled>
        {{noResultsDisplay}}
      </mat-option>
    }

    <!-- Results Options -->
    @for (option of chipOptions; track option) {
      @if (!option.isSelected) {
        <mat-option [value]="option">
          @if (optionTemplate?.elementRef === null) {
            {{option.label}}
          } @else {
            <template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{item: option.model}"></template>
          }
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
